import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FeedbackModal = ({ 
  isCorrect, 
  xpEarned, 
  badgeUnlocked, 
  encouragementMessage, 
  onContinue 
}) => {
  return (
    <div className="fixed inset-0 bg-foreground/50 flex items-center justify-center z-50 p-4 animate-fade-in">
      <div className="bg-background rounded-lg shadow-elevation-3 max-w-md w-full p-8 text-center animate-scale-in">
        <div className={`w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center ${
          isCorrect ? 'bg-success/10' : 'bg-warning/10'
        }`}>
          <Icon 
            name={isCorrect ? 'CheckCircle' : 'AlertCircle'} 
            size={48} 
            className={isCorrect ? 'text-success' : 'text-warning'} 
          />
        </div>

        <h2 className="text-2xl font-bold text-foreground mb-3">
          {isCorrect ? 'Excellent Work!' : 'Keep Trying!'}
        </h2>

        <p className="text-base text-muted-foreground mb-6 leading-relaxed">
          {encouragementMessage}
        </p>

        {isCorrect && (
          <div className="space-y-4 mb-6">
            <div className="flex items-center justify-center gap-3 p-4 rounded-lg bg-secondary/10 border border-secondary/20">
              <Icon name="Zap" size={24} className="text-secondary" />
              <div className="text-left">
                <p className="text-sm text-muted-foreground">XP Earned</p>
                <p className="text-xl font-bold text-secondary">+{xpEarned} XP</p>
              </div>
            </div>

            {badgeUnlocked && (
              <div className="flex items-center justify-center gap-3 p-4 rounded-lg bg-accent/10 border border-accent/20">
                <Icon name="Award" size={24} className="text-accent" />
                <div className="text-left">
                  <p className="text-sm text-muted-foreground">Badge Unlocked</p>
                  <p className="text-base font-semibold text-accent">{badgeUnlocked}</p>
                </div>
              </div>
            )}
          </div>
        )}

        <Button
          variant="default"
          size="lg"
          fullWidth
          onClick={onContinue}
          iconName="ArrowRight"
          iconPosition="right"
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default FeedbackModal;